var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25V6",
    stroke: "#94A3B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C16.3333 4.5 12 0.75 12 0.75C12 0.75 7.5 4.5 12 6Z",
    stroke: "#94A3B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 11.8125C15.1875 12.6579 14.8517 13.4686 14.2539 14.0664C13.6561 14.6642 12.8454 15 12 15C11.1546 15 10.3439 14.6642 9.7461 14.0664C9.14832 13.4686 8.8125 12.6579 8.8125 11.8125",
    stroke: "#94A3B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 11.8125C8.8125 12.6471 8.48515 13.4484 7.90077 14.0443C7.31639 14.6402 6.52161 14.9831 5.68716 14.9994C3.90018 15.0336 2.4375 13.5368 2.4375 11.7495V10.5C2.4375 9.90326 2.67455 9.33097 3.09651 8.90901C3.51847 8.48705 4.09076 8.25 4.6875 8.25H19.3125C19.9092 8.25 20.4815 8.48705 20.9035 8.90901C21.3254 9.33097 21.5625 9.90326 21.5625 10.5V11.7495C21.5625 13.5368 20.0998 15.0336 18.3128 14.9994C17.4784 14.9831 16.6836 14.6402 16.0992 14.0443C15.5149 13.4484 15.1875 12.6471 15.1875 11.8125",
    stroke: "#94A3B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.3691V19.5001C20.25 19.699 20.171 19.8898 20.0303 20.0305C19.8897 20.1711 19.6989 20.2501 19.5 20.2501H4.5C4.30109 20.2501 4.11032 20.1711 3.96967 20.0305C3.82902 19.8898 3.75 19.699 3.75 19.5001V14.3692",
    stroke: "#94A3B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/Cake.d8ce282608b2dfae6b0b38366f54674c.svg";
export { ForwardRef as ReactComponent };